import i18n from '@/i18n/index';

const LANGUAGES_CAPITALISING_NOUNS = Object.freeze(['de']);

const BYTES_PER_GIGABYTE = 10 ** 9;

const CONJUNCTIONS = Object.freeze({
  de: 'und',
  el: 'και',
  en: 'and',
  es: 'y',
  fr: 'et',
  it: 'e',
  nl: 'en',
  pt: 'e',
});

export function arrToSentence(arr) {
  const arr_clone = _.cloneDeep(arr);
  let lastWord = '';
  if (arr_clone.length > 1) {
    const conjunction = CONJUNCTIONS[i18n.global.locale.value];
    const word_last = arr_clone.pop();
    lastWord = conjunction ? ` ${conjunction} ${word_last}` : `, ${word_last}`;
  }
  return arr_clone.join(', ') + lastWord;
}

// German capitalises every noun, so lowercasing a translated string mangles it.
export function decapitalize(s) {
  if (typeof s !== 'string') return s;
  return LANGUAGES_CAPITALISING_NOUNS.includes(i18n.global.locale.value) ? s : s.toLowerCase();
}

export function titleize(s) {
  if (typeof s === 'string') {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }
  // do nothing in case of null/undefined/...
  return s;
}

export function orderAlphabetically({ collection, val = 'attributes.name', direction = 'asc' }) {
  return _.orderBy(collection, [val.toLowerCase()], [direction]);
}

export function formatFileSize(bytes, decimalPoint, k = 1000) {
  if (bytes === 0) return '0 Bytes';
  const dm = decimalPoint || 0;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Number.parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
}

export function formatGigabytes(bytes, locale, fraction_digits = 2) {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: fraction_digits }).format(
    (bytes || 0) / BYTES_PER_GIGABYTE,
  );
}

export function htmlToTextLines(content_html) {
  if (!content_html) return '';
  const element = document.createElement('div');
  // oxlint-disable-next-line unicorn/prefer-string-replace-all -- the i flag is the point: pasted HTML can carry </P>
  element.innerHTML = content_html.replaceAll(/<\/p>/gi, '</p>\n').replaceAll(/<br\s*\/?>/gi, '\n');
  return element.textContent || '';
}

export function collapseSpaces(string) {
  return string.replaceAll(/\s+/g, ' ').trim();
}
